import { usePatient } from '../contexts/PatientContext'

/**
 * Custom hook for Patient View pages to access selected patient and filter data
 * @returns {Object} Object containing selected patient and helper functions
 */
export const usePatientFilter = () => {
    const { selectedPatient, updateSelectedPatient, clearSelectedPatient } = usePatient()

    /**
     * Check if a patient is currently selected
     * @returns {boolean} True if a patient is selected
     */
    const hasSelectedPatient = () => {
        return selectedPatient !== null
    }

    /**
     * Get the selected patient ID
     * @returns {string|null} The selected patient ID or null
     */
    const getSelectedPatientId = () => {
        return selectedPatient?.id || null
    }

    /**
     * Get the selected patient name
     * @returns {string|null} The selected patient name or null
     */
    const getSelectedPatientName = () => {
        return selectedPatient?.name || null
    }

    /**
     * Filter data by selected patient
     * @param {Array} data - Array of objects with user_id or patient_id field
     * @param {string} idField - Field name to match against (default: 'user_id')
     * @returns {Array} Filtered data array
     */
    const filterBySelectedPatient = (data, idField = 'user_id') => {
        if (!hasSelectedPatient() || !data) {
            return data || []
        }

        return data.filter(item => item[idField] === getSelectedPatientId())
    }

    return {
        selectedPatient,
        hasSelectedPatient,
        getSelectedPatientId,
        getSelectedPatientName,
        filterBySelectedPatient,
        updateSelectedPatient,
        clearSelectedPatient,
    }
} 